module.exports = __webpack_public_path__ + "media/review-badges/rank-2k-55d78de7.svg";